export default class APIService {
  
  static serverUrl = process.env.REACT_APP_API_URL || "RUNTIME_REPLACE_REACT_APP_API_URL";
  static captchaKey = process.env.REACT_APP_CAPTCHA_KEY || "RUNTIME_REPLACE_REACT_APP_CAPTCHA_KEY";
  
}
